// Auto-generated translation for pt.
// Source: kennisbank.js, translated via Claude Sonnet on 2026-05-26T11:00:45.574428+00:00.

export const KENNISBANK = {
  "paarden-gezondheid": {
    slug: "paarden-gezondheid",
    category: "Saúde",
    title: "Saúde equina — guia completo",
    lead: "A saúde equina começa com uma boa observação, manutenção estruturada de registros e o envolvimento oportuno de profissionais. Neste guia, explicamos os fundamentos: sinais diários, controlos, prevenção e quando ligar ao veterinário.",
    datePublished: "2026-05-01",
    sections: [
      {
        h: "O que é saúde equina?",
        p: "Saúde equina é mais do que \"não estar doente\". Trata-se de um sistema locomotor funcionando bem, uma digestão saudável, equilíbrio mental e cuidados preventivos regulares. O EquiSight apoia todos esses pilares num único registo por cavalo.",
      },
      {
        h: "Sinais diários",
        list: [
          "Apetite e consumo de água",
          "Comportamento na boxe e no pasto",
          "Fezes (consistência, frequência)",
          "Postura e movimento",
          "Pelagem e condição da pele",
          "Frequência cardíaca e respiração em repouso",
        ],
      },
      {
        h: "Gestão preventiva",
        p: "Uma boa saúde equina é, em grande parte, prevenção. Mantenha um registo consistente de vacinações, desparasitações, controlos dentários e cuidados com os cascos. O EquiSight envia lembretes automáticos.",
      },
      {
        h: "Quando ligar ao veterinário?",
        list: [
          "Sem comer nem beber (>4 horas)",
          "Sinais de cólica",
          "Claudicação súbita",
          "Febre alta (>38,5°C)",
          "Feridas que não param de sangrar",
          "Complicações no parto",
        ],
      },
    ],
    faq: [
      {
        q: "Com que frequência um cavalo deve ir ao dentista?",
        a: "Uma vez por ano para cavalos adultos. Cavalos jovens (3–5 anos) e séniores devem ir com mais frequência.",
      },
      {
        q: "Quais são as vacinas obrigatórias?",
        a: "Para competições da KNHS, a vacinação contra influenza de acordo com o calendário é obrigatória. A vacinação contra o tétano é fortemente recomendada.",
      },
    ],
    related: [
      "entingen",
      "voeradvies",
      "hoefverzorging",
    ],
  },
  "voeradvies": {
    slug: "voeradvies",
    category: "Nutrição",
    title: "Aconselhamento alimentar para cavalos — regras básicas e armadilhas comuns",
    lead: "Uma boa alimentação é a base da saúde equina. Neste guia: feno, ração concentrada, suplementos, peso e o índice de frutanos explicado.",
    datePublished: "2026-05-02",
    sections: [
      {
        h: "Quanto feno um cavalo precisa?",
        p: "Um cavalo médio precisa de 1,5–2% do seu peso corporal em forragem (feno/silagem) por dia. Para um cavalo de 500kg, isso representa 7,5–10kg de feno.",
      },
      {
        h: "Ração concentrada — quando é necessária?",
        p: "A ração concentrada só é necessária em casos de trabalho intensivo, gestação, lactação ou necessidades energéticas especiais. Muitos cavalos recebem ração concentrada desnecessariamente, o que leva ao excesso de peso e a problemas metabólicos.",
      },
      {
        h: "Suplementos",
        list: [
          "Sal/minerais (disponíveis livremente)",
          "Magnésio para stress / músculos",
          "Biotina para problemas nos cascos",
          "Glucosamina para as articulações",
        ],
      },
      {
        h: "Índice de frutanos — cuidado com a erva",
        p: "O teor de frutanos na erva é especialmente elevado durante a manhã na primavera e em dias com noites frias e tempo ensolarado. Representa um risco para a laminite. O EquiSight alerta automaticamente.",
      },
    ],
    faq: [
      {
        q: "Preciso sempre de dar ração concentrada?",
        a: "Não. Muitos cavalos ficam bem apenas com boa forragem e um suplemento mineral. A ração concentrada só deve ser usada quando há maior necessidade energética.",
      },
      {
        q: "Como sei se o meu cavalo tem excesso de peso?",
        a: "Através da pontuação de condição corporal (BCS) e de uma fita de medição. O EquiSight ajuda-o a acompanhar a evolução e emite alertas sobre tendências.",
      },
    ],
    related: [
      "fructaan-index",
      "paarden-gezondheid",
    ],
  },
  "hoefverzorging": {
    slug: "hoefverzorging",
    category: "Cuidados com os Cascos",
    title: "Cuidados com os cascos do cavalo — o que você precisa saber",
    lead: "Sem casco, sem cavalo. Os cuidados com os cascos exigem consistência: aparar ou ferrar, inspeção regular, estábulo seco e boa alimentação.",
    datePublished: "2026-05-03",
    sections: [
      {
        h: "Com que frequência o ferrador deve vir?",
        p: "Em média a cada 6–8 semanas. Com ferraduras, o intervalo pode ser um pouco menor; sem ferraduras, às vezes pode ser um pouco maior. Mantenha a regularidade — o EquiSight envia lembretes automaticamente.",
      },
      {
        h: "Com ferradura ou sem ferradura?",
        p: "Ambas as opções podem funcionar bem, dependendo do cavalo, da disciplina e das condições do estábulo e do pasto. Consulte o seu ferrador.",
      },
      {
        h: "Sinais de problemas nos cascos",
        list: [
          "Marcha irregular",
          "Pulso digital palpável nas artérias",
          "Calor no casco",
          "Rachaduras ou lascamento",
          "Ranilha com mau cheiro",
        ],
      },
    ],
    faq: [
      {
        q: "O que faz exatamente um ferrador?",
        a: "Apara e corrige o casco (aparar e alisar o casco), ajusta ou coloca ferraduras novas quando necessário, e avalia a saúde geral do casco.",
      },
    ],
    related: [
      "paarden-gezondheid",
    ],
  },
  "entingen": {
    slug: "entingen",
    category: "Saúde",
    title: "Vacinação do cavalo — esquema, tipos e regras",
    lead: "Quais vacinas um cavalo precisa? Influenza, tétano, rinopneumonia e vírus do Nilo Ocidental. Esquemas e regras da KNHS explicados.",
    datePublished: "2026-05-04",
    sections: [
      {
        h: "Influenza",
        p: "Primeira série de 3 vacinações (semana 0, 4, 6 meses), depois anualmente. Obrigatório para competições da KNHS e vacinado há no máximo 6 meses.",
      },
      {
        h: "Tétano",
        p: "Primeira série de 2 (semana 0 e 4 semanas), depois a cada 2–3 anos. Fortemente recomendado para todos os cavalos.",
      },
      {
        h: "Rinoneumonia (EHV-1/4)",
        p: "Especialmente em estábulos com muitos cavalos e em éguas gestantes. A cada 6 meses.",
      },
      {
        h: "Vírus do Nilo Ocidental",
        p: "Recomendado em áreas de risco. Anualmente, antes da época dos mosquitos.",
      },
    ],
    faq: [
      {
        q: "E se o meu cavalo estiver com a vacinação em atraso?",
        a: "No caso da influenza, muitas vezes é necessário reiniciar a série básica. O EquiSight avisa a tempo.",
      },
    ],
    related: [
      "paarden-gezondheid",
    ],
  },
  "fructaan-index": {
    slug: "fructaan-index",
    category: "Nutrição",
    title: "Índice de fructano no cavalo — o que é e como utilizá-lo",
    lead: "O que é o índice de fructano? Quando é que a erva é perigosa para o seu cavalo? Como prevenir a laminite com dados e planeamento.",
    datePublished: "2026-05-05",
    sections: [
      {
        h: "O que é o fructano?",
        p: "O fructano é um açúcar armazenado pela erva. Em concentrações elevadas, pode provocar fermentação no intestino grosso e, consequentemente, laminite.",
      },
      {
        h: "Quando é que o fructano está elevado?",
        list: [
          "Noites frias + dias soalheiros (primavera, outono)",
          "Início da manhã",
          "Após geada noturna",
          "Erva em stress (após corte, seca, pastagem curta)",
        ],
      },
      {
        h: "Como acompanhar o índice?",
        p: "O EquiSight calcula o índice de fructano por pastagem e emite alertas em caso de risco elevado. Combine com os horários de pastoreio para uma gestão otimizada.",
      },
    ],
    faq: [
      {
        q: "Quais os cavalos com maior risco?",
        a: "Póneis (especialmente Shetland e Welsh), cavalos com excesso de peso, cavalos com SME e Cushing, e cavalos com historial de laminite.",
      },
    ],
    related: [
      "voeradvies",
      "paarden-gezondheid",
    ],
  },
  "koliek": {
    slug: "koliek",
    category: "Doenças",
    title: "Cólica em cavalos — sintomas, causas e o que fazer",
    lead: "Cólica é dor abdominal. Em cavalos, é sempre grave — ligue imediatamente para o veterinário em caso de dúvida. Leia aqui sobre sintomas, causas e primeiros socorros.",
    datePublished: "2026-05-06",
    sections: [
      {
        h: "Sintomas",
        list: [
          "Não comer nem beber",
          "Agitação, raspar o chão com os cascos",
          "Deitar e levantar repetidamente",
          "Olhar ou dar coices para a barriga",
          "Suar sem esforço físico",
          "Frequência cardíaca elevada (>48/min)",
        ],
      },
      {
        h: "Causas",
        list: [
          "Mudanças na alimentação",
          "Ingestão insuficiente de água (especialmente no inverno)",
          "Excesso de concentrados",
          "Ingestão de areia",
          "Estresse",
          "Infecção por vermes",
        ],
      },
      {
        h: "O que fazer?",
        p: "Ligue imediatamente para o veterinário. Não deixe o cavalo rolar se a cólica for grave. Caminhe tranquilamente com ele se for possível. Evite dar comida ou água até a chegada do veterinário.",
      },
    ],
    faq: [
      {
        q: "Posso prevenir a cólica?",
        a: "Em parte: forneça forragem de forma estável, água suficiente, exercício adequado, vermifugação regular e evite mudanças bruscas na alimentação.",
      },
    ],
    related: [
      "paarden-gezondheid",
      "voeradvies",
    ],
  },
  "droes": {
    slug: "droes",
    category: "Doenças",
    title: "Garrotilho no cavalo — sintomas, contágio & isolamento",
    lead: "O garrotilho (strangles) é altamente contagioso. O reconhecimento rápido e o isolamento são essenciais para evitar surtos no estábulo.",
    datePublished: "2026-05-07",
    sections: [
      {
        h: "Sintomas",
        list: [
          "Febre (>39°C)",
          "Falta de apetite",
          "Inchaço abaixo da mandíbula",
          "Corrimento nasal purulento",
          "Abscessos que rompem",
        ],
      },
      {
        h: "Isolamento",
        p: "Coloque o cavalo suspeito em quarentena imediatamente. Cuidados separados, materiais separados, higiene rigorosa. Rastrear os outros cavalos.",
      },
    ],
    faq: [
      {
        q: "Quanto tempo dura o garrotilho?",
        a: "Geralmente 2–6 semanas. Alguns cavalos tornam-se portadores através das bolsas guturais — solicite uma avaliação veterinária.",
      },
    ],
    related: [
      "paarden-gezondheid",
    ],
  },
  "zomereczeem": {
    slug: "zomereczeem",
    category: "Doenças",
    title: "Eczema de verão em cavalos — prevenção e tratamento",
    lead: "O eczema de verão é uma reação alérgica à saliva de mosquitos-borrachudos (Culicoides). Leia sobre prevenção e tratamento.",
    datePublished: "2026-05-08",
    sections: [
      {
        h: "Sintomas",
        list: [
          "Coceira, especialmente na crina e na base da cauda",
          "Manchas sem pelo e crostas",
          "Agitação ao entardecer e ao amanhecer",
        ],
      },
      {
        h: "Prevenção",
        list: [
          "Manta anti-eczema com proteção abdominal e capuz",
          "Recolher ao estábulo nos horários de pico (pôr do sol / nascer do sol)",
          "Repelente de insetos",
          "Ventilador no estábulo",
          "Manter longe de cursos e espelhos d'água",
        ],
      },
    ],
    faq: [
      {
        q: "A alimentação ajuda contra o eczema de verão?",
        a: "Alguns suplementos (ômega-3, vitamina E) apoiam a saúde da pele e a imunidade, mas não curam a condição.",
      },
    ],
    related: [
      "paarden-gezondheid",
    ],
  },
};

export default KENNISBANK;
